export enum AdministerUserStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export interface IAdministerUser {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  initial: string;
  loginId: string;
  email: string;
  joinedDate: string;
  role: string;
  application: string;
  status: AdministerUserStatus;
  isActive: boolean;
}
